var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerFullScreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 603,
    height: 603,
    viewBox: "0 0 603 603",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.22,
    width: 603,
    height: 603,
    rx: 301.5,
    fill: "url(#paint0_radial_1_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(301.5 301.5) rotate(90) scale(301.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D01A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52022",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerFullScreen);
export default __webpack_public_path__ + "static/media/PlayerFullScreen.609957ac6262c29109d7ccb85651dc4a.svg";
export { ForwardRef as ReactComponent };